import styled from 'styled-components';

import { CLIENTE_TABS, TabConfig } from '../tabs-config';

interface Props {
  activeKey: string;
  onChange: (key: string) => void;
}

const Bar = styled.div`
  display: flex;
  gap: 4px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  overflow-x: auto;
  padding: 0 4px;
  margin: 0 -4px;

  /* hide scrollbar but keep functionality */
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.colors.border} transparent;
`;

interface TabBtnProps {
  $active: boolean;
  $disabled: boolean;
}

const TabBtn = styled.button<TabBtnProps>`
  flex-shrink: 0;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  color: ${({ theme, $active, $disabled }) => {
    if ($disabled) return theme.colors.textMuted;
    if ($active) return theme.colors.primary;
    return theme.colors.textSecondary;
  }};
  border-bottom-color: ${({ theme, $active }) =>
    $active ? theme.colors.primary : 'transparent'};
  opacity: ${({ $disabled }) => ($disabled ? 0.55 : 1)};
  transition: color ${({ theme }) => theme.transitions.fast},
    border-color ${({ theme }) => theme.transitions.fast};

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.colors.primary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
    border-radius: ${({ theme }) => theme.radius.sm};
  }
`;

const ComingSoonChip = styled.span`
  margin-left: 8px;
  padding: 2px 6px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  background: ${({ theme }) => theme.colors.bgMuted};
  color: ${({ theme }) => theme.colors.textMuted};
`;

export const ClienteTabs = ({ activeKey, onChange }: Props) => (
  <Bar role="tablist" aria-label="Seções do cliente">
    {CLIENTE_TABS.map((tab: TabConfig) => {
      const isActive = tab.key === activeKey;
      const isDisabled = !tab.enabled;
      return (
        <TabBtn
          key={tab.key}
          type="button"
          role="tab"
          $active={isActive}
          $disabled={isDisabled}
          disabled={isDisabled}
          aria-selected={isActive}
          aria-disabled={isDisabled || undefined}
          title={isDisabled ? 'Em breve' : undefined}
          onClick={() => {
            if (!isDisabled) onChange(tab.key);
          }}
          data-testid={`cliente-tab-${tab.key}`}
        >
          {tab.label}
          {tab.comingSoon && <ComingSoonChip>Em breve</ComingSoonChip>}
        </TabBtn>
      );
    })}
  </Bar>
);
